import React from 'react';
import { useQueryString, getQueryStringValue } from '../../../../hooks';
import { globalHistory } from '@reach/router';

const useModalQueryString = ({ queryId, setModalOpen }) => {
    const [queryStringValue, onSetValue] = useQueryString(queryId);

    // initial modal state based on quesry string
    React.useEffect(() => {
        const modalShouldBeOpen = queryStringValue === 'true';
        setModalOpen(modalShouldBeOpen);
        // eslint-disable-next-line
    }, []);

    // handle history backward/forward
    React.useEffect(() => {
        return globalHistory.listen(({ location }) => {
            const modalShouldBeOpen = getQueryStringValue(queryId, location.search) === 'true';
            setModalOpen(modalShouldBeOpen);
        });
        // eslint-disable-next-line
    }, []);

    return { onSetValue, queryStringValue };
};

export default useModalQueryString;
